(function() {
	'use strict';
	angular.module('app.leanProjects')
	.controller('viewTasks', viewTasks);

	viewTasks.$inject = ['$scope', '$rootScope', '$state', '$location', '$timeout', 'leanFilterService', 'leanTableService',
		'tableRenderService','tableService', 'URLS', 'redirectParamsService', 'storeService', '$experiments'];

	function viewTasks($scope, $rootScope, $state, $location, $timeout, leanFilterService, leanTableService,
			tableRenderService, tableService, URLS, redirectParamsService, storeService, $experiments) {
		var columns = [
			{
				'id': 'taskName',
				'display': 'Task Name',
				'width': 240,
				'type': 'task',
				'renderer': tableRenderService.hyperLink
			},
			{
				'id': 'businessUnit',
				'display': 'Business Unit',
				'show':false,
				'width': 240
			},
			{
				'id': 'projectArea',
				'display': 'Project Area',
				'show':false,
				'width': 120
			},
			{
				'id': 'projectCategory',
				'display': 'Project Category',
				'width': 150
			},
			{
				'id': 'initiativeId',
				'display': 'Project ID',
				'width': 120,
				'show': false
			},
			{
				'id': 'projectName',
				'display': 'Project Name',
				'width': 240,
				'type': 'project',
				'renderer': tableRenderService.hyperLink,
				'enableGrouping': true
			},
			{
				'id': 'stageSequence',
				'display': 'Stage',
				'width': 150,
				'show': false,
				'renderer': tableRenderService.projectStageRenderer,
				'sort': false
			},
			{
				'id': 'factoryName',
				'display': 'Site',
				'width': 140
			},
			{
				'id': 'responsible',
				'display': 'Responsible',
				'width': 140,
				'enableGrouping': true

			},
			{
				'id': 'stateType',
				'display': 'Status',
				'width': 120
			},
			{
				'id': 'percentComplete',
				'display': '% Complete',
				'width': 120,
				'renderer':tableRenderService.percent
			},
			{
				'id': 'taskNumericPriority',
				'display': 'Priority',
				'width': 120,
				'renderer':tableRenderService.taskPriority
			},
			{
				'id': 'startDate',
				'display': 'Start Date',
				'show':false,
				'width': 100,
				'renderer': tableRenderService.dateRenderer,
				'convertTimeZone': true
			},
			{
				'id': 'dueDate',
				'display': 'Due Date',
				'width': 100,
				'renderer': tableRenderService.dueDate,
				'statusColumn': 'stateType',
				'convertTimeZone': true
			},
			{
				'id': 'projectManager',
				'display': 'Project Manager',
				'width': 140
			},
			{
				'id': 'taskGroup',
				'display': 'Task Group',
				'width': 140
			},
			{
				'id': 'lastModified',
				'display': 'Last Update',
				'width': 140,
				'renderer': tableRenderService.relativeDate
			}
		];

		var vm = this;
		var unsubscribe;
		var completeWidthMap = {};
		var reportSettingsName = 'view-tasks';
		var viewLink = '/application/f/home.html#/lean-projects/edit-project?fromLocation=view-tasks&projectNdx=';

		//Set correct navigation highlighting
		if (Object.keys($location.search()).length === 0 && redirectParamsService.hasRedirectParams() ) {
			$location.search(redirectParamsService.popRedirectParams());
		}
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.reportName = 'Tasks (lean projects)';
		vm.showExcel = true;
		vm.broadcastExcel = broadcastExcel;
		vm.initialLoad = true;
		vm.stageListMap = {};
		var pinnedColumns = [];
		var rendererParams = {
			'viewLink': viewLink,
			stageListMap: vm.stageListMap,
			completeWidthMap: completeWidthMap
		};

		var extraParams = [{
			excelReportName: 'ViewTasks',
			selectedList:vm.selectedList
		}];

		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: 'ViewTasks',
			noPaging: false,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultSort: 'taskName',
			defaultSortDirection: 'asc',
			rendererParams: rendererParams,
			pageSize: 50,
			recordsPerPage: 50,
			reportUrl: URLS.viewTasks,
			searchType: 'task',
			viewLink: viewLink,
			extraParams:extraParams,
			setColumnDefaults: true,
			isBackendGrouping: true
		};

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.searchPlaceholderText = 'Search tasks...';

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showSaveReport = !reportSettingsId;
		vm.baseReportDisplay = vm.reportName;
		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.isSavedReport = false;
			vm.reportName = vm.reportName;
		}
		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});
		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});

		if (reportSettingsId) {
			$scope.$on('reportConfigFailed', function() {
				navigateToBaseReport();
			});
		}

		function getData(params, extraParams, isFilterChanged) {
			return tableService.getData(params, extraParams).then(function (response) {
				if (response && response[0] && response[0].stagesBySite) {
					processStages(response[0].stagesBySite);
				}
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		function processStages(stagesBySites) {
			vm.stageListMap = stagesBySites;
			rendererParams.stageListMap = vm.stageListMap;
			angular.forEach(vm.stageListMap, function (stagesBySite, siteId) {
				completeWidthMap[siteId] = Math.max((stagesBySite.length - 2) * 18 + stagesBySite.length - 1, 58) + 'px';
			});
		}

		function getMeta() {
			return meta;
		}

		$scope.filterService = leanFilterService;
		$scope.tableService = leanTableService;
		$scope.tableService.setReportSettingsName(reportSettingsName);
		$scope.filterService.searchType = 'task';

		function init() {
			$scope.filterService.clearFilters();
			leanFilterService.useFactoryFilter = true;
			var defaultFilters  = [
				{'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true},
				{'id': 'projectArea', 'values': [$scope.filterService.leanDnaAllSelected]},
				{'id': 'projectStageId', 'values': [$scope.filterService.leanDnaAllSelected]}
			];
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterStringFilterList([]);
			$scope.useFactoryFilter = false;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'multiselect';
			siteFilter.removable = false;
			var filters = [
				$scope.filterService.filterDefinitions.BusinessUnit,
				siteFilter,
				$scope.filterService.filterDefinitions.ProjectArea,
				$scope.filterService.filterDefinitions.ProjectCategories,
				$scope.filterService.filterDefinitions.ProjectManager,
				$scope.filterService.filterDefinitions.ProjectStageWithPendingApproval,
				$scope.filterService.filterDefinitions.ProjectTypes,
				$scope.filterService.filterDefinitions.ProjectGoals,
				$scope.filterService.filterDefinitions.Responsible,
				$scope.filterService.filterDefinitions.ProjectTaskStatus
			];
			$scope.filterService.setMasterFilterList(filters);
			$scope.filterService.setMasterSingleSelectFilterList([$scope.filterService.filterDefinitions.ProjectTaskDueDate]);
		}

		function broadcastExcel() {
			$rootScope.$broadcast('export-excel', {doChooseColumns: true});
		}

		init();
	}
})();
